import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { UserAvatar } from '../../avatars';
import { classNames } from '@wix/answers-lib';
import { Popover } from '../../primitives';
import { DeprecatedText } from '../../deprecated-typography';
export var UserPresenceKey = 'user-presence';
export var PresenceType;
(function (PresenceType) {
    PresenceType[PresenceType["VIEWING"] = 0] = "VIEWING";
    PresenceType[PresenceType["TYPING"] = 1] = "TYPING";
    PresenceType[PresenceType["TALKING"] = 2] = "TALKING";
})(PresenceType || (PresenceType = {}));
var UserPresence = /** @class */ (function (_super) {
    __extends(UserPresence, _super);
    function UserPresence() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isAdditionalUsersOpen: false,
        };
        _this.tp = function (key, params) {
            return _this.props.t(UserPresenceKey + "." + key, params);
        };
        _this.toggleAdditionalUsers = function () {
            _this.state.isAdditionalUsersOpen
                ? _this.setState({ isAdditionalUsersOpen: false })
                : _this.setState({ isAdditionalUsersOpen: true });
        };
        _this.renderAdditionalUsers = function (additionalUsers) { return (additionalUsers.map(function (au) { return (React.createElement("li", { key: au.user.id },
            React.createElement(UserAvatar, { user: au.user, size: 'xsmall' }),
            React.createElement(DeprecatedText, { type: 't1a' }, au.user.fullName))); })); };
        return _this;
    }
    UserPresence.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state, tp = _a.tp;
        var showText = !!props.showText;
        var diff = props.presenceUserData.length - 1;
        var _b = props.presenceUserData[0], type = _b.type, user = _b.user;
        var additionalUsers = diff > 0 ? props.presenceUserData.filter(function (_, i) { return i !== 0; }) : [];
        var additionalUsersList = (React.createElement("ul", { className: 'additional-users' },
            React.createElement("li", null,
                React.createElement(DeprecatedText, { className: 'type', type: 't4a' }, 'Agents Viewing:')),
            this.renderAdditionalUsers(additionalUsers)));
        var classes = {
            viewing: type === PresenceType.VIEWING,
            talking: type === PresenceType.TALKING,
            typing: type === PresenceType.TYPING
        };
        var presenceAvatars = (React.createElement("div", { className: namespacedClassnames('presence-avatars', { clickable: diff > 0 }), onClick: this.toggleAdditionalUsers },
            React.createElement(UserAvatar, { className: namespacedClassnames(classes), user: user, size: 'xsmall' }),
            diff > 0 ? React.createElement("span", { className: 'additional-users-avatar' },
                React.createElement("span", null, "+" + diff)) : null));
        var presenceAvatarsWithPopover = (React.createElement(Popover, { isOpen: state.isAdditionalUsersOpen, body: additionalUsersList, onOuterAction: this.toggleAdditionalUsers, preferPlace: 'above' }, presenceAvatars));
        var single = diff === 0 ?
            React.createElement(DeprecatedText, { className: 'name', type: 't4a' }, props.presenceUserData[0].user.firstName) : null;
        var presenceText = (React.createElement("div", { className: classNames('presence-text', { multi: diff > 0 }) },
            single,
            React.createElement(DeprecatedText, { className: 'type', type: 't4a' }, tp("type." + type)),
            React.createElement("span", { className: 'dots' }, "...")));
        return (React.createElement("div", { className: namespacedClassnames(UserPresenceKey, props.className) },
            diff > 0 ? presenceAvatarsWithPopover : presenceAvatars,
            showText && presenceText));
    };
    return UserPresence;
}(React.PureComponent));
export { UserPresence };
//# sourceMappingURL=index.js.map